<template>
	<div>
		<busquedaAlumno />
		<br />
		<div v-if="jsonAlumno.length == 0" style="margin-bottom: 250px;"></div>
		<alumnoComponet v-if="jsonAlumno.length != 0"></alumnoComponet>
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import busquedaAlumno from "@/components/alumno/busquedaAlumno";
import alumnoComponet from "@/components/alumno/infoAlumno";
export default {
	components: {
		alumnoComponet,
		busquedaAlumno,
	},
	data() {
		return {
			selected: "",
		};
	},
	computed: {
		...mapState("alumno", ["jsonAlumno"]),
	},
	methods: {
		...mapActions("menu", ["updateMenu"]),
		...mapActions("menu", ["updateTitulo"]),
		...mapActions("alumno", ["updateJsonAlumno"]),
	},
	mounted() {
		this.updateJsonAlumno("");

		let menu = [
			{
				urlTolbar: "index",
				nameToolbar: "Inicio",
			},
			{
				urlTolbar: "busquedaAlumno",
				nameToolbar: "Busqueda Alumno",
			},
		];
		let titulo = "Panel búsqueda alumno";
		this.updateTitulo(titulo);
		this.updateMenu(menu);
	},
};
</script>
